import logo from "../img/logo-new.png";
import "../DesktopView.css";

function DesktopView() {
    return (
        <div className="maintenance-container">
            <div className="maintenance-content">
                <div className="logo-container">
                    <img src={logo} alt="Comptaride Logo" className="logo" />
                </div>

                <h1 className="title">Expérience optimale sur mobile</h1>

                <div className="message-box">
                    <p className="message">
                        Comptaride est optimisé pour une utilisation mobile.
                        Pour une meilleure expérience, merci d'accéder à la plateforme
                        depuis votre smartphone.
                    </p>

                    <div className="url-container">
                        <a
                            href="https://comptaride.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="website-link"
                        >
                            https://comptaride.com/
                        </a>
                    </div>
                </div>

                <div className="animation-container">
                    <div className="floating-phone">
                        📱
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DesktopView;